// @flow
import {
    INTEGRATIONS_GTAG,
    INTEGRATIONS_GTAG_SUCCESS,
    INTEGRATIONS_GTAG_FAILED,
    INTEGRATIONS_GTAG_SAVE
} from '../../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    gtag: null
};

type IntegrationsAction = { type: string, payload: {} | string };
type State = { loading?: boolean, +value?: boolean, gtag?: {} | null, saving?: boolean};

const IntegrationsGtag = (state:State = INIT_STATE, action: IntegrationsAction) => {
    switch (action.type) {
        case INTEGRATIONS_GTAG:
            return { ...state, loading: true };
        case INTEGRATIONS_GTAG_SAVE:
            return { ...state, saving: true };
        case INTEGRATIONS_GTAG_SUCCESS:
            return { ...state, gtag: action.payload, loading: false, saving: false, error: null };
        case INTEGRATIONS_GTAG_FAILED:
            return { ...state, error: action.payload, loading: false, saveing: false };
        default: return { ...state };
    }
}

export default IntegrationsGtag;